import { collections } from "@/mocks/comicData";

function Collections() {
  return (
    <section id="collections" className="bg-background-100 py-16 md:py-20">
      <div className="container-page">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="eyebrow">
              <i className="ri-play-list-2-line"></i>
              搞笑片段合集
            </span>
            <h2 className="section-title mt-3">笑点合集，打包带走</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            把大黄丫头漫画的幽默片段按主题打包成合集，一键轻松看，通勤摸鱼睡前都能刷，快乐不重样。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((col) => (
            <article
              key={col.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-50"
            >
              <div className="relative h-40 overflow-hidden md:h-44">
                <img
                  src={col.img}
                  alt={`${col.title} 大黄丫头漫画搞笑合集`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 to-transparent"></div>
                <span className="absolute bottom-3 left-3 flex items-center gap-1 text-sm font-bold text-background-50">
                  <i className="ri-play-circle-line"></i>
                  {col.count} 篇幽默片段
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg text-foreground-950 group-hover:text-primary-700">
                  {col.title}
                </h3>
                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">
                  {col.desc}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(col.views / 1000).toFixed(1)}w 次轻松看
                  </span>
                  <span className="flex items-center gap-1 font-bold text-primary-600">
                    进入合集
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Collections;